<template>
  <div>
    <h1>How to Support Unmatched Maker</h1>
    <p>
      Some people have asked if there's a way they can donate to help support
      Unmatched Maker. While I deeply appreciate the sentiment, Unmatched Maker
      is a labour of love. I have no plans to accept donations; the costs are
      minimal and I enjoy doing the work.
    </p>
    <p>
      I do love hearing from people who use and enjoy the site, so if you really
      want to express your support, I'd love to hear from you!
      <router-link :to="{ name: 'Contact' }">Get in touch</router-link>,
      introduce yourself, make suggestions or bug reports, maybe we can even
      play a round online!
    </p>
    <p>
      Thanks!
    </p>
    <p>
      &ndash; Jonathan
    </p>
  </div>
</template>

<script>
export default {
  name: "SupportTheSite",
  metaInfo: {
    title: "Support the site"
  }
};
</script>
